var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7916 20C15.647 20 20.1326 18.8475 20.1326 10.7804V9.62793C20.1326 8.47279 20.943 7.51612 22 7.34892C21.7594 6.18119 20.7687 5.30624 19.5832 5.30624C19.4166 5.30624 19.2539 5.32351 19.0965 5.35644C17.9976 5.35644 16.2863 8.47532 15.7368 9.05154C15.2973 9.51252 14.5 9 14.0884 8.47532C13.6769 7.95063 13.3192 6.86192 10.2421 5.01813C8.25405 3.9757 6.28941 3.86636 4.72544 4.10707C3.52293 4.29214 2.55729 4.68417 2 5.01813C2.35047 5.20188 2.81272 5.52628 3.2798 5.9876C3.48768 6.19291 3.69651 6.42534 3.89687 6.68457C4.65796 7.66924 4.1979 8.2255 5.29684 10.7802C6.39579 13.3349 9.20283 14.9605 11.2463 15.3715C10.1445 16.7817 8.38205 17.6951 6.39579 17.6951C5.82565 17.6951 5.27395 17.6198 4.75101 17.4792C6.32617 19.0418 8.45217 20 10.7916 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDove);
export default __webpack_public_path__ + "static/media/dove.4b8831a76572c0c4128b53e0521d2e23.svg";
export { ForwardRef as ReactComponent };